import { t } from '@lingui/macro';
import * as yup from 'yup';
export const schema = yup.object({
    name: yup
        .string()
        .trim()
        .required(t({
        comment: 'Prompt name is required validation message in create/update prompt modal for property `name`',
        message: 'Prompt name is required.',
    }))
        .max(70, t({
        comment: 'Prompt name is too long validation message in create/update prompt modal for property `name`',
        message: 'Prompt name is too long.',
    })),
    content: yup
        .string()
        .trim()
        .required(t({
        comment: 'Validation message in create/update prompt modal for property `description`',
        message: 'Prompt description is required.',
    })),
    isPublic: yup.bool().required(),
    labels: yup.array(yup.string().trim().required()).required(),
});
